import type { FieldProps } from "@ui/components/forms/field/Field";
import { Field } from "@ui/components/forms/field/Field";
import { FormControl } from "@ui/components/forms/form-control/FormControl";
import { FormErrorMessage } from "@ui/components/forms/form-control/FormError";
import { FormLabel } from "@ui/components/forms/form-control/FormLabel";
import { Input } from "@ui/components/forms/input/Input";

import type { StyleProps } from "@ui/types";

type Props = {
    isInvalid: boolean;
    label: string;
    error: string;
    id: string;
    styles: {
        field: StyleProps;
        label: StyleProps;
        errorMessage: StyleProps;
        errorField: StyleProps;
    };
    fieldProps?: FieldProps;
};

export const FooterInput = ({ isInvalid, label, error, styles, id, fieldProps }: Props) => {
    return (
        <FormControl data-privacy="true" isRequired isInvalid={isInvalid}>
            <FormLabel {...styles.label} htmlFor={id}>
                {label}
            </FormLabel>

            <Field
                as={Input}
                id={id}
                name={id}
                type="text"
                {...styles.field}
                {...(isInvalid && styles.errorField)}
                {...(fieldProps ? fieldProps : {})}
            />
            <FormErrorMessage {...styles.errorMessage}>{error}</FormErrorMessage>
        </FormControl>
    );
};
